import { Navigate } from "react-router-dom";

export default function CoachEarnings() {
  return <Navigate to="/revenue-center?view=coach" replace />;
}
